// extracted by mini-css-extract-plugin
export default {"content":"DeleteStep_content__Q3OGa","buttons":"DeleteStep_buttons__FKiVX"};